import {content} from '@/api/seaService/client';

const api = {content};

export default api;
